import { useState, useEffect } from 'react';
import { aiManagementApi } from '../../api/aiManagement.api';
import { PageHeader, Spinner, EmptyState } from '../../components/ui/index';
import { toPersian } from '../../utils/persianNumber';
import { useAutoRefresh } from '../../hooks/useAutoRefresh';
import { ChartBar, Question, PencilSimple, TrendDown, Smiley, Trophy } from '@phosphor-icons/react';

function StatList({ title, items, renderRow, icon: Icon }) {
  return (
    <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 20 }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
        {Icon && <Icon size={16} weight="regular" />} {title}
      </h3>
      {(!items || items.length === 0) ? <EmptyState icon={<ChartBar size={44} weight="regular" />} title="داده‌ای یافت نشد" /> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {items.map((it, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', background: '#f8faff', borderRadius: 8 }}>
              {renderRow(it)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function AIStatisticsPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = (showSpinner = true) => {
    if (showSpinner) setLoading(true);
    return aiManagementApi.getAIStatistics().then(r => setStats(r.data)).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);
  useAutoRefresh(() => load(false));

  if (loading) return <div className="fade-in"><PageHeader title="آمار تفصیلی هوش مصنوعی" /><Spinner /></div>;
  if (!stats) return null;

  return (
    <div className="fade-in">
      <PageHeader title="آمار تفصیلی هوش مصنوعی" subtitle="سوالات پرتکرار بی‌پاسخ، پاسخ‌های پرویرایش، دپارتمان‌های ضعیف و بهترین دسته‌بندی‌ها" />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <StatList title="پرتکرارترین سوالات بی‌پاسخ" icon={Question} items={stats.most_common_unanswered}
          renderRow={it => <><span style={{ fontSize: 12, color: '#334155' }}>{it.title}</span><span style={{ fontSize: 12, fontWeight: 700, color: '#dc2626' }}>{toPersian(it.count)}</span></>} />

        <StatList title="پرتکرارترین پاسخ‌های ویرایش‌شده" icon={PencilSimple} items={stats.frequently_edited}
          renderRow={it => <><span style={{ fontSize: 12, color: '#334155' }}>{it.title}</span><span style={{ fontSize: 12, fontWeight: 700, color: '#b45309' }}>{toPersian(it.count)}</span></>} />

        <StatList title="دپارتمان‌های با کمترین دقت AI" icon={TrendDown} items={stats.lowest_ai_accuracy_departments}
          renderRow={it => <><span style={{ fontSize: 12, color: '#334155' }}>{it.department}</span><span style={{ fontSize: 12, fontWeight: 700, color: '#dc2626' }}>{toPersian(it.satisfaction_rate)}%</span></>} />

        <StatList title="رضایت مشتری به تفکیک دپارتمان" icon={Smiley} items={stats.csat_by_department}
          renderRow={it => <><span style={{ fontSize: 12, color: '#334155' }}>{it.department}</span><span style={{ fontSize: 12, fontWeight: 700, color: '#059669' }}>{toPersian(it.satisfaction_rate)}%</span></>} />

        <StatList title="برترین دسته‌بندی‌های AI" icon={Trophy} items={stats.top_ai_categories}
          renderRow={it => <><span style={{ fontSize: 12, color: '#334155' }}>{it.category}</span><span style={{ fontSize: 12, fontWeight: 700, color: '#059669' }}>{toPersian(it.satisfaction_rate)}%</span></>} />
      </div>
    </div>
  );
}
